function InventorySyncSingleSku() {
	return {
		fields: [
			'singleSkuSync.singleItem',
			'singleSkuSync.singleItem[].sku',
			'singleSkuSync.singleItem[].quantity',
		],
		labels: {
			'singleSkuSync.singleItem[].sku': 'PRODUCTVIEW.VIRTUALSKU',
		}
	};
}

export default InventorySyncSingleSku;



// WEBPACK FOOTER //
// ./src/modules/product-inventory/forms/InventorySyncSingleSkuForm.js